import React, { FC } from "react";
import { HardwareSubCmds } from "../../../../constants/sub-commands";
import { useLocale } from "../../../../contexts/localeContext";
import { TableContextProvider } from "../../../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import ModesColumns from "../../../../models/ColumnDefinitions/ModeColumns";
import { ListData } from "../../../../models/ListData";
import { ListQuery } from "../../../../models/ListQuery";
import TableTab from "../../../tabs/table-tab";
export interface SelectBiometricTypeProps {
    onNext: (e) => void;
    selectedBrand: any;
    setSelectedBrand: (mode: any) => void;
}

export const SelectScanFilters: FC<SelectBiometricTypeProps> = ({ onNext, selectedBrand, setSelectedBrand }) => {
    const { translate } = useLocale();

    const onRowClicked = (rowData: any) => {
        const newSelectedMode = {
            ...selectedBrand,
            id: rowData.id,
            name: rowData.nameOriginal,
            value: rowData.value,
        }
        setSelectedBrand(newSelectedMode);
    }

    const getFilterTypes = (listParameters?: ListQuery): Promise<ListData> => {
        const rows = [{
            id: 1,
            name: "Idemia",
            value: HardwareSubCmds.Discover_Idemia,
            nameOriginal: "Idemia"
        },
        {
            id: 2,
            name: "Control iD",
            value: HardwareSubCmds.Discover_ControlId,
            nameOriginal: "Control iD"
        },
        {
            id: 3,
            name: "Hikvision",
            value: HardwareSubCmds.Discover_HIK_Vision,
            nameOriginal: "HikVision"
        },
        {
            id: 4,
            name: "Hid Amico",
            value: HardwareSubCmds.Discover_ControlId,
            nameOriginal: "Hid Amico"
        }]

        return new Promise((resolve, reject) => {
            return resolve({
                rows: rows,
                pagination: { maxPageSize: 10, pageNumber: 1, totalCount: rows.length, totalPages: 1 }
            });
        })
    }

    const handleNext = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        // todo?: set ip address values if one is selected but the other not.
        // if () {
        // }
        if (onNext && selectedBrand.id){
            onNext(e);
        }
    };

    return <div className="flex flex-col pt-3 pr-3 h-full relative">
        <div className="flex flex-row pt-3">
            <TableContextProvider
                dataMethod={getFilterTypes}
                tableDescriptor={ModesColumns}
                searchDescriptor={[]}
                useTable
                usePagination
                canExportReport={false}>
                <TableTab
                    title={translate.byKey(TranslationKeys.selectABrand)}
                    selectRows={false}
                    onRowClicked={(data) => onRowClicked(data)}
                    cyName="selectScanFilter"/>
            </TableContextProvider>
        </div>
        <div className="flex flex-row justify-end w-full absolute bottom-0 pr-3 pb-3 ">
            <div>
                <button
                    className={`py-1 px-5 mt-3 secondary  ${!(selectedBrand.id) ? 'secondary-disabled cursor-not-allowed' : 'secondary-enabled'}`}
                    type="button"
                    disabled={!selectedBrand.id ? true : false}
                    onClick={handleNext}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>
    </div>;
};
